import React, { Component } from "react";

import { Container } from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import CampaignCashbackBlock from "../components/CampaignCashbackBlock";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  getCampaignCashbackProfile,
  setCampaignCashbackProfile,
  updateCampaignCashbackProfile,
} from "../../../../store/campaigns/cashbacks/actions";
import { getMetaCountries } from "../../../../store/meta/actions";
import { getCampaignSourcesList } from "../../../../store/campaigns/sources/actions";
import { getServiceProvidersList } from "../../../../store/service-provider/actions"
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';

class CampaignCashbackProfile extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.setCampaignCashbackProfile(null);
    this.props.getMetaCountries();
    this.props.getCampaignCashbackProfile(this.props.match.params.cashbackId);
    this.props.getCampaignSourcesList({
      ...this.props.sources,
      sizePerPage: 0,
    });
    this.props.getServiceProvidersList({
      ...this.props.service_providers,
      sizePerPage: 0,
    })
  }

  saveChanges = data => {
    this.props.updateCampaignCashbackProfile(
      this.props.match.params.cashbackId,
      data
    );
    this.props.history.push(`/cashbacks`);
  };

  render() {
    const history = this.props.history;
    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Cashback profile  | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Campaign cashbacks"
              link="/cashbacks"
              breadcrumbItem={this.props.profile?.name}
            />
            {this.props.profile && this.props.countries ? (
              <CampaignCashbackBlock
                cashback={this.props.profile}
                countries={this.props.countries}
                saveChangeAction={this.saveChanges}
                history={history}
                readOnly={!this.props.permissions["change_cashbackmodel"]}
                loading={this.props.loading}
                service_providers_loading={this.props.service_providers_loading}
                service_providers={
                  this.props.service_providers
                    ? [
                      {
                        label: 'None',
                        value: null
                      }
                      ,
                      ...this.props.service_providers?.results.map(i => {
                        return {
                          label: i.counterparty_name,
                          value: i.id,
                        };
                      })
                    ]
                    : []
                }
                sources_loading={this.props.sources_loading}
                sources={
                  this.props.sources
                    ? this.props.sources?.results.map(i => {
                      return {
                        label: i.name,
                        value: i.id,
                      };
                    })
                    : []
                }
              />
            ) : null}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CampaignCashbackProfile.propTypes = {
  setCampaignCashbackProfile: PropTypes.func,
  getMetaCountries: PropTypes.func,
  getCampaignCashbackProfile: PropTypes.func,
  updateCampaignCashbackProfile: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cashbackId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  history: PropTypes.any,
  countries: PropTypes.any,
  profile: PropTypes.any,
  permissions: PropTypes.any,
  loading: PropTypes.bool,
  sources: PropTypes.object,
  service_providers: PropTypes.object,
  service_providers_loading: PropTypes.bool,
  sources_loading: PropTypes.bool,
  getCampaignSourcesList: PropTypes.func,
  getServiceProvidersList: PropTypes.func,
};

const mapStateToProps = state => ({
  countries: state.Meta.countries,
  profile: state.CampaignCashbackList.profile,
  sources: state.CampaignSourceList.data,
  service_providers: state.ServiceProviders.data,
  service_providers_loading: state.ServiceProviders.loading_list,
  permissions: state.User.permissions,
  loading: state.CampaignCashbackList.loading,
  sources_loading: state.CampaignCashbackList.loading,
  loading: state.CampaignCashbackList.loading,
});

export default withRouter(
  connect(mapStateToProps, {
    setCampaignCashbackProfile,
    getCampaignCashbackProfile,
    updateCampaignCashbackProfile,
    getMetaCountries,
    getCampaignSourcesList,
    getServiceProvidersList,
  })(CampaignCashbackProfile)
);
